<template>
    <CommonList
            selection-type="radio"
            row-key="companyId"
            :has-more-search="false"
            :auto-load="true"
            ref="listRef"
            cellOverflow="ellipsis"
            @selection-change="handleSelectionChange"
            @current-row-change="handleCurrentRowChange"
            @load-start="handleLoadList"
            @search-click="handleLoadList"
            @pagination-change="handleLoadList"
            @reset-click="handleReset"
    >
        <!-- 固定搜索区 -->
        <template #search-item-fixed>
            <div class="common-search-item">
                <label class="common-search-label80">公司ID：</label>
                <el-input v-model="searchForm.companyId" class="common-input120" placeholder="请输入公司ID"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">公司名称：</label>
                <el-input v-model="searchForm.companyName" class="common-input120" placeholder="请输入公司名称"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">是否生效：</label>
                <el-select v-model="searchForm.isDeleted" class="common-input100" placeholder="请选择">
                    <el-option label="是" value="0"></el-option>
                    <el-option label="否" value="1"></el-option>
                </el-select>
            </div>
        </template>

        <!-- 操作按钮 -->
        <template #btn-group>
            <el-button type="primary" class="list-btn" @click="handleAdd">
                <el-icon>
                    <Plus/>
                </el-icon>
                新增公司
            </el-button>
            <el-button
                    type="warning"
                    class="list-btn"
                    @click="handleEdit"
                    :disabled="!selectedRow"
            >
                <el-icon>
                    <Edit/>
                </el-icon>
                修改公司
            </el-button>
            <el-button
                    type="danger"
                    class="list-btn"
                    @click="handleDelete"
                    :disabled="!selectedRow || selectedRow?.isDeleted === 0"
            >
                <el-icon>
                    <Delete/>
                </el-icon>
                删除公司
            </el-button>
        </template>

        <!-- 表格列 width="auto" 占剩余宽度 :resizable="false" 不可拖拽-->
        <template #table-column>
            <el-table-column prop="companyId" label="公司ID" align="center" width="120"></el-table-column>
            <el-table-column prop="companyName" label="公司名称" align="center" width="180"></el-table-column>
            <el-table-column prop="companyType" label="公司类型" align="center" width="120"></el-table-column>
            <el-table-column prop="contactPhone" label="联系电话" align="center" width="130"></el-table-column>
            <el-table-column prop="companyAddress" label="公司地址" align="center" min-width="200"></el-table-column>
            <el-table-column prop="miniProgramCode" label="小程序编码" align="center" min-width="250" show-overflow-tooltip></el-table-column>
            <el-table-column prop="isDeleted" label="是否生效" align="center" width="100">
                <template #default="scope">
                    <el-tag :class="scope.row.isDeleted == 0? 'list-status-normal' : 'list-status-deleted'">
                        {{ scope.row.isDeleted == 0? '是' : '否' }}
                    </el-tag>
                </template>
            </el-table-column>
        </template>

        <!-- 新增/编辑弹窗 -->
        <template #extra>
            <el-dialog
                    v-model="dialogVisible"
                    :title="dialogType === 'add' ? '新增公司' : '修改公司'"
                    width="500px"
                    destroy-on-close
            >
                <el-form
                        ref="formRef"
                        :model="formData"
                        :rules="formRules"
                        label-width="100px"
                        class="list-modal-form"
                >
                    <el-form-item label="公司ID" prop="companyId" v-if="dialogType === 'edit'">
                        <el-input
                                v-model="formData.companyId"
                                disabled
                                placeholder="请输入公司ID"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称" prop="companyName">
                        <el-input
                                v-model="formData.companyName"
                                placeholder="请输入公司名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="公司类型" prop="companyType">
                        <el-select v-model="formData.companyType" placeholder="请选择公司类型" style="width: 100%;">
                            <el-option v-for="item in companyTypeList" :key="item.code" :label="item.enumCodeName" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="contactPhone">
                        <el-input
                                v-model="formData.contactPhone"
                                placeholder="请输入联系电话"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="公司地址" prop="companyAddress">
                        <el-input
                                v-model="formData.companyAddress"
                                type="textarea"
                                :rows="2"
                                placeholder="请输入公司地址"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="小程序编码" prop="miniProgramCode">
                        <el-input
                                v-model="formData.miniProgramCode"
                                placeholder="请输入小程序编码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="是否生效" prop="isDeleted">
                        <el-radio-group v-model="formData.isDeleted">
                            <el-radio :label=0>是</el-radio>
                            <el-radio :label=1>否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <template #footer>
                    <div style="text-align: center; width: 100%;">
                        <el-button @click="dialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="handleSubmit">确定</el-button>
                    </div>
                </template>
            </el-dialog>
        </template>
    </CommonList>
</template>

<script setup>
    import useCompanyList from './companyList.js';
    import {  } from 'vue';
    const {
        searchForm,
        listRef,
        dialogVisible,
        dialogType,
        formRef,
        selectedRow,
        formData,
        formRules,
        Plus, Edit, Delete,
        handleSelectionChange,
        handleCurrentRowChange,
        handleAdd,
        handleEdit,
        handleDelete,
        handleSubmit,
        handleLoadList,
        handleReset,
        companyTypeList
    } = useCompanyList();
</script>

<style>
    @import '../../../assets/css/util/base-list.css';
</style>
